import React, { useContext, useState } from 'react';
import { Switch, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import SafetyCard from './SafetyCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const TheftProtectionAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [armed, setArmed] = useState(false);
  const [loading, setLoading] = useState(false);

  const triggerTheftAlert = async () => {
    setLoading(true);
    const newArmedState = !armed;
    await triggerAlert(
      { serialNo, vehicleKey, actual: newArmedState ? 'ARMED' : 'DISARMED', threshold: '' },
      credentials,
      ALERT_CATEGORY.THEFT_PROTECTION_ALERT
    )
      .then(() => {
        setArmed(newArmedState);
        messageApi.success(`Security system ${newArmedState ? 'armed' : 'disarmed'}`);
        onTriggered?.({ success: true, value: newArmedState ? 'Armed' : 'Disarmed' });
      })
      .catch(() => {
        messageApi.error('Failed to toggle theft protection');
        onTriggered?.({ success: false, value: newArmedState ? 'Armed' : 'Disarmed' });
      })
      .finally(() => setLoading(false));
  };

  return (
    <SafetyCard
      title="Theft Protection"
      icon={<LockOutlined />}
      iconBg="#eff6ff"
      iconColor="#2563eb"
      protectionLevel="High"
      onTrigger={triggerTheftAlert}
      triggerLabel={armed ? 'Disarm System' : 'Arm System'}
      loading={loading}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ fontSize: 11, color: '#64748b' }}>System Status</Text>
        <Text style={{ fontSize: 12, fontWeight: 700, color: armed ? '#16a34a' : '#ef4444' }}>
          {armed ? '🔒 Armed' : '🔓 Disarmed'}
        </Text>
      </div>
      <div
        style={{
          padding: '10px 12px',
          borderRadius: 8,
          background: '#f8fafc',
          border: '1px solid #e2e8f0',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: armed ? '#16a34a' : '#94a3b8', flexShrink: 0 }} />
        <Text style={{ fontSize: 11, color: '#64748b' }}>
          {armed ? 'Vehicle is protected. Alerts active.' : 'Vehicle unprotected. Arm the system.'}
        </Text>
      </div>
    </SafetyCard>
  );
};

export default TheftProtectionAlert;
